'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { type RouterOutputs } from '../../utils/trpc';
import Avatar from '../common/Avatar';
type Props = {
  boards: RouterOutputs['spaces']['get']['headerBoards'];
};
const HeaderBoards = t0 => {
  const $ = _c(4);
  const {
    boards
  } = t0;
  if (boards.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== boards) {
    t1 = boards.map(_temp);
    $[0] = boards;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="mx-4 flex items-center gap-2 overflow-x-auto py-1">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default HeaderBoards;
function _temp(board) {
  return <Link key={board.id} href={`/s/${board.slug}`} className="flex shrink-0 items-center gap-1.5 rounded-full border border-ds-border-subtle bg-background-secondary/60 px-3 py-1.5 text-sm font-semibold text-textSecondary no-underline transition-colors hover:bg-hover hover:text-textPrimary"><Avatar spaceAvatarKey={board.avatarKey} size={20} className="rounded" /><span className="max-w-[120px] truncate">{board.name}</span></Link>;
}